import React, { useEffect } from "react";
import { Card, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTypes } from "../../../Utils/constant";
import { fetchBorrowerDashboardPayOffDetails } from "../../../store/reducers/dashboardSlice/api";
import { useAbortController } from "../../../hooks/useAbortController";
import CommonGrid from "../../../components/CommonGrid";
import { gridColumns_Borrower_Payoff_Details } from "../../../Utils/TableColumnDefs";

const payOffFilter = [
  {
    name: "Status",
    key: "status",
    type: "select",
    options: [
      { label: "All", value: "all" },
      { label: "Expired", value: "Expired" },
    ],
  },
];

function OpenActivePayOff({ loanIdArr }) {
  const data = useSelector(
    (state) => state.dashboard.borrowerPayOffDetails.data
  );

  const status = useSelector(
    (state) => state.dashboard.borrowerPayOffDetails.status
  );
  // const loanId = useSelector((state) => state.account.lenderId);
  const { signal } = useAbortController();
  const dispatch = useDispatch();

  useEffect(() => {
    if (loanIdArr?.length) {
      dispatch(
        fetchBorrowerDashboardPayOffDetails({ loanId: loanIdArr, signal })
      );
    }
  }, [dispatch, loanIdArr?.length]);

  return (
    <>
      <Card className="p-4 border-primary h-100">
        {/* <h6>Open/Active Payoff Demands</h6> */}
        <div>
          <CommonGrid
            className={"bg-white col-sm-12 mt-5"}
            title={"Active Demand Payoff Loans"}
            gridColumns={gridColumns_Borrower_Payoff_Details}
            columnData={loanIdArr?.length ? data : []}
            status={loanIdArr?.length ? status : "fulfilled"}
            filterOption={payOffFilter}
          />
        </div>
      </Card>
    </>
  );
}

export default OpenActivePayOff;
